// localStorage quota guard — see Login.js and CachedGridThumbnail.js.
//
// The signage File Manager thumbnail cache (CachedGridThumbnail.js) stores base64
// thumbnails under `thumb_*` keys and can fill the entire ~5MB localStorage origin
// quota. Once full, EVERY localStorage.setItem throws QuotaExceededError — which
// silently broke the auth-token write on login, surfacing as "The quota has been
// exceeded." and an endless failed login.
//
// These helpers let CRITICAL writes (the auth token) survive a full cache by evicting
// the regenerable thumbnail cache and retrying. The thumbnail cache also evicts itself
// on quota (see CachedGridThumbnail.setCachedThumbnail) so it can never starve them again.
// (.100 has no stationTokenStore like MAESTRO, so this is a small standalone util —
//  analogous to maestro commit 1cd9c7b.)

export function evictThumbCache(fraction = 1) {
  try {
    const items = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.indexOf('thumb_') === 0) {
        let ts = 0;
        try { ts = (JSON.parse(localStorage.getItem(k)) || {}).timestamp || 0; } catch (e) {}
        items.push([k, ts]);
      }
    }
    items.sort((a, b) => a[1] - b[1]); // oldest first
    const n = fraction >= 1 ? items.length : Math.ceil(items.length * fraction);
    for (let i = 0; i < n && i < items.length; i++) localStorage.removeItem(items[i][0]);
    return n;
  } catch (e) { return 0; }
}

export function safeSetItem(key, value) {
  try { localStorage.setItem(key, value); return true; }
  catch (e) {
    // Cache full -> drop the (regenerable) thumbnail cache and retry once so the
    // critical write still lands.
    if (evictThumbCache(1) > 0) {
      try { localStorage.setItem(key, value); return true; } catch (e2) {}
    }
    return false;
  }
}
